// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomProfessionalView from './view'

export default function DataVaxiomProfessionalViewFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomProfessionalView">
      <DataVaxiomProfessionalView {...props}>
        {children}
      </DataVaxiomProfessionalView>
    </Flow>
  )
}
